var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard_wrp"},[(!_vm.isMobile)?_c('dash-sidebar'):_vm._e(),_c('router-view'),_c('user-chatbot'),(_vm.incomingCallNotification)?_c('video-call',{attrs:{"callerInfo":_vm.callerInfo,"roomId":_vm.roomId}}):_vm._e(),_c('networkIssuePopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }